import Table from "@app/components/table";
import { ColumnConfig, Order } from "@app/components/table/table.component";
import {
  DATE_TIME_FORMAT_1,
  DEFAULT_PAGE,
  DEFAULT_REQUEST_PARAMS,
  OrderType,
  TransactionOption,
  TransactionOptionName,
} from "@app/constants";
import WithdrawHistoryService from "@app/services/http/witdraw.history.service";
import { Meta, WithdrawHistory } from "@app/types";
import { formatDateTime, formatMoneyVN } from "@app/utils/util";
import { RequestParams } from "@core/services/http/http.type";
import clsx from "clsx";
import { useEffect, useState } from "react";

function CreateDateColumnTable({ data }: { data: WithdrawHistory }) {
  return <div>{formatDateTime(data.createdDate, DATE_TIME_FORMAT_1)}</div>;
}

function AmountColumnTable({ data }: { data: WithdrawHistory }) {
  return (
    <div>
      {typeof data.amount === "number"
        ? `${formatMoneyVN(data.amount)} đ`
        : "-"}
    </div>
  );
}

function AmountRemainingColumnTable({ data }: { data: WithdrawHistory }) {
  return (
    <div>
      {typeof data.remainingAmount === "number"
        ? `${formatMoneyVN(data.remainingAmount)} đ`
        : "-"}
    </div>
  );
}

function StatusCollumnTable({ data }: { data: WithdrawHistory }) {
  return (
    <div>
      <span
        className={clsx("px-4 py-2 rounded-lg text-xs", {
          "bg-[#E8FFF4] text-[#00A653]":
            data.status === TransactionOption.SUCCESS,
          "bg-[#FFF0E6] text-[#FE7E20]":
            data.status === TransactionOption.TIMEOUT,
          "bg-[#CCE7FF] text-[#4558FF]":
            data.status === TransactionOption.PROCESSING,
          "bg-[#E8FFF4] text-[#FC4040]":
            data.status === TransactionOption.ERROR,
        })}
      >
        {TransactionOptionName[data.status]}
      </span>
    </div>
  );
}

const columnConfig: ColumnConfig[] = [
  {
    label: "Thời gian",
    dataKey: "createdDate",
    width: "128px",
    tdClassName: "truncate min-w-[128px] max-w-[128px]",
    component: CreateDateColumnTable,
    hasOrder: true,
  },
  {
    label: "Số tiền rút",
    dataKey: "amount",
    width: "112px",
    tdClassName: "truncate min-w-[112px] max-w-[112px]",
    component: AmountColumnTable,
    hasOrder: true,
  },
  {
    label: "Số dư còn lại",
    dataKey: "remainingAmount",
    width: "112px",
    component: AmountRemainingColumnTable,
    tdClassName: "truncate min-w-[112px] max-w-[112px]",
    hasOrder: true,
  },
  {
    label: "Số tài khoản nhận",
    dataKey: "bank",
    width: "5%",
    tdClassName: "truncate min-w-[220px] max-w-[220px]",
    hasOrder: true,
  },
  {
    label: "Trạng thái",
    dataKey: "status",
    width: "106px",
    tdClassName: "min-w-[106px] max-w-[106px]",
    component: StatusCollumnTable,
    hasOrder: true,
  },
];

function WithdrawHistoryManagement() {
  const [histories, setHistories] = useState<WithdrawHistory[]>([]);

  const [requestParams, setRequestParams] = useState<RequestParams>(
    DEFAULT_REQUEST_PARAMS
  );
  const [meta, setMeta] = useState<Meta>();

  useEffect(() => {
    WithdrawHistoryService.getTransferHistory(requestParams).then((res) => {
      setHistories(res.data.items);
      setMeta(res.data.meta);

      if (
        requestParams.pageNum &&
        res.data.meta.totalPage > 0 &&
        res.data.meta.totalPage < requestParams.pageNum
      ) {
        const newRequestParams: RequestParams = {
          ...requestParams,
          pageNum: DEFAULT_PAGE,
        };

        setRequestParams(newRequestParams);
      }
    });
  }, [requestParams]);

  const onPageChange = (page: number) => {
    const newRequestParams: RequestParams = { ...requestParams, pageNum: page };

    setRequestParams(newRequestParams);
  };

  const onPageSizeChange = (pageSize: number) => {
    const newRequestParams: RequestParams = { ...requestParams, pageSize };

    setRequestParams(newRequestParams);
  };

  const onOrderChange = (data?: Order) => {
    if (data) {
      const newRequestParams: RequestParams = {
        ...requestParams,
        sortBy: data.orderBy,
        sortType: data.order as OrderType,
      };

      setRequestParams(newRequestParams);
    }
  };

  return (
    <div className="py-6 px-12">
      <div className="mt-6 rounded-xl bg-white py-6 px-5">
        <div className="mt-6">
          <Table
            columnConfig={columnConfig}
            dataTable={histories}
            meta={meta}
            onPageChange={onPageChange}
            onPageSizeChange={onPageSizeChange}
            onRowClickOrder={onOrderChange}
            componentEmpty={
              <div className="text-center py-3 bg-[#f4f4f4]">
                <p className="text-[#666] text-xl">Không có dữ liệu</p>
              </div>
            }
          />
        </div>
      </div>
    </div>
  );
}

export default WithdrawHistoryManagement;
